export default __webpack_public_path__ + "static/media/cloud-live.3f274c96.svg";